import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/vini-trackerlogov2.png'
import _imports_1 from '../assets/themeOn.svg'


const _withScopeId = n => (_pushScopeId("data-v-063b4490"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "has-text-centered" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Logo do Vini Tracker"
  })
], -1))
const _hoisted_2 = { class: "has-text-centered" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "theme",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "panel mt-5" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-tasks" }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" tarefas ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-project-diagram" }, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" projetos ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleTema && _ctx.toggleTema(...args)))
      }, [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_ctx.textButton), 1)
      ])
    ]),
    _createElementVNode("nav", _hoisted_4, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "link"
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/projetos",
            class: "link"
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}